<template>
  <el-dropdown @command="changeLang" class="nav_text" trigger="click">
    <span>
      <i class="el-icon-3d-language"></i>
      <span class="dp_title">{{langName}}</span>
      <i class="el-icon-arrow-down el-icon--right"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="item in langs" :key="item.value" :command="item.value">{{item.label}}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import Cookies from "js-cookie";
// import ELUlocale from 'element-ui/lib/locale';
export default {
  name: "lang",
  data() {
    return {
      langs: [
        { value: "cn", label: "中文" },
        { value: "en", label: "English" }
      ],
      lang: ""
    };
  },
  computed: {
    langName() {
      switch (this.lang) {
        case "cn":
          return "中文";
        case "en":
          return "English";
      }
    }
  },
  methods: {
    changeLang(v) {
      //   console.log(v);
      Cookies.set("lang", v,{expires: 36500});
      this.$i18n.locale = v;
      // console.log(this);
      this.$EventBus.$emit("clang", v);
      // ELUlocale.use(v);
    }
  },
  mounted() {
    console.log(pub.defaultLang);
    this.lang = Cookies.get("lang") || pub.defaultLang;
    this.$i18n.locale = this.lang;
    Cookies.set("lang", this.lang,{expires: 36500});
  },
  beforeDestroy() {
    this.$EventBus.$off("clang");
  }
};
</script>
<style lang="scss">
.nav_text {
  color: #4b91d1;
  /* margin-left: 15px; */
  /* border: 1px solid #4b91d1; */
  padding: 5px 10px;
  cursor: pointer;
  span {
    .dp_title {
      @media only screen and (max-width: 1020px) {
        display: none;
      }
    }
  }
}
</style>
